import { Archetype, Lego, TaskType } from '../task/task';
import { ExecutionType } from './execution-request';

type Execution = {
  refId: string;
  project: ExecutionProject;
  tasks: ExecutionTask[];
};

type ExecutionProject = {
  projectName: string;
  applicationName: string;
  apmId: string;
};

type ExecutionTask = {
  id: string;
  inputParams: ExecutionInputParam[];
  archetypeId?: string;
};

class ExecutionTaskFactory {
  static create(
    taskId: string,
    inputParams: ExecutionInputParam[],
    archetypeId?: string
  ): ExecutionTask {
    return { id: taskId, inputParams, archetypeId };
  }
}

type ExecutionInputParam = {
  id: string;
  value: string;
};

class ExecutionInputParamFactory {
  static fromObject(obj: any): ExecutionInputParam[] {
    return Object.keys(obj).map((key) => {
      return { id: key, value: obj[key] };
    });
  }
}

type ExecutionContract = {
  type: ExecutionType;
  ids: string[];
};

class ExecutionContractFactory {
  static create(tasks: (Lego | Archetype)[]): ExecutionContract {
    const ids = tasks.flatMap((task) =>
      'legos' in task ? task.legos.map((lego) => lego.id) : [task.id]
    );
    const isWorkflow = tasks.some((task) => task.type === TaskType.Workflow);

    return {
      type: isWorkflow ? ExecutionType.Workflow : ExecutionType.Lego,
      ids
    };
  }
}

type UserExecutionParams = {
  limit: number;
  offset: number;
  beginDate: string;
  endDate: string;
};

type UsersExecutionsResponse = {
  userName: string;
  totalExecutions: number;
  legos: string[];
};

type LegoExecutionParams = {
  limit: number;
  offset: number;
  searchValue: string;
  beginDate: string;
  endDate: string;
};

type LegosExecutionsResponse = {
  legosExecutionCount: LegoExecutionCount[];
  total: number;
};

type LegoExecutionCount = {
  name: string;
  tags: string;
  state: string;
  totalExecutions: number;
  totalStandalone: number;
  totalArchetype: number;
};

type ArchetypeExecutionParams = {
  limit: number;
  offset: number;
  searchValue: string;
  beginDate: string;
  endDate: string;
};

type ArchetypeExecutionResponse = {
  name: string;
  legoCategories: string[];
  state: string;
  associatedLegos: string[];
  totalExecutions: number;
};

type Filters = {
  searchValue?: string;
  stateExecution?: string;
  beginDate: string;
  endDate: string;
};

export {
  Execution,
  ExecutionTask,
  ExecutionInputParam,
  ExecutionProject,
  ExecutionInputParamFactory,
  ExecutionTaskFactory,
  ExecutionContract,
  ExecutionContractFactory,
  Filters,
  UserExecutionParams,
  UsersExecutionsResponse,
  LegoExecutionParams,
  LegosExecutionsResponse,
  LegoExecutionCount,
  ArchetypeExecutionParams,
  ArchetypeExecutionResponse
};
